import React from "react";

const EditIconLight = () => {
  return (
    <svg
      style={{ transform: "scale(0.8)" }}
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8328 18.0716H7.83269C7.46468 18.0716 7.16602 17.773 7.16602 17.405C7.16602 17.0369 7.46468 16.7383 7.83269 16.7383H19.8328C20.2008 16.7383 20.4995 17.0369 20.4995 17.405C20.4995 17.773 20.2008 18.0716 19.8328 18.0716Z"
        fill="white"
      />
      <path
        d="M1.16649 18.0726C0.991357 18.0726 0.821596 18.0042 0.695293 17.8771C0.531717 17.7135 0.465147 17.478 0.517557 17.2531L1.48648 13.1419C1.51496 13.0211 1.57616 12.9108 1.66422 12.8237L13.9212 0.566718C14.6751 -0.18801 15.9941 -0.189801 16.7497 0.566718L18.0067 1.82357C18.3844 2.20134 18.5925 2.70362 18.5925 3.23781C18.5925 3.77216 18.3844 4.27525 18.0067 4.65205L5.74955 16.9082C5.66166 16.9963 5.5513 17.0576 5.43135 17.0859L1.32014 18.0549C1.2687 18.0674 1.21711 18.0726 1.16649 18.0726V18.0726ZM2.74073 13.6318L2.0625 16.5099L4.94078 15.8317L17.0635 3.709C17.1898 3.5827 17.2591 3.41571 17.2591 3.23781C17.2591 3.06007 17.1898 2.8921 17.0635 2.76677L15.8066 1.50895C15.555 1.25732 15.115 1.25732 14.8644 1.50895L2.74073 13.6318ZM5.27754 16.4372H5.28649H5.27754Z"
        fill="white"
      />
      <path
        d="M14.8448 7.53581C14.6742 7.53581 14.5035 7.47087 14.3737 7.34017L11.2305 4.19707C10.9701 3.93665 10.9701 3.51445 11.2305 3.25403C11.4911 2.99345 11.9133 2.99345 12.1737 3.25403L15.3168 6.39713C15.5772 6.65755 15.5772 7.07975 15.3168 7.34017C15.1861 7.47087 15.0155 7.53581 14.8448 7.53581Z"
        fill="white"
      />
    </svg>
  );
};

export default EditIconLight;
